/**
 * Event arguments for the DataCommitting event.
*/
var IgrGridDataCommittingEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridDataCommittingEventArgs() {
    }
    Object.defineProperty(IgrGridDataCommittingEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridDataCommittingEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridDataCommittingEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridDataCommittingEventArgs.prototype, "changes", {
        /**
         * Gets a list of changes that are about to be committed.
        */
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridDataCommittingEventArgs.prototype, "commitID", {
        /**
         * The ID for the commit. Use this as the argument for the AcceptCommit or RejectCommit methods.
        */
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = +v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridDataCommittingEventArgs;
}());
export { IgrGridDataCommittingEventArgs };
//# sourceMappingURL=igr-grid-data-committing-event-args.js.map
